export const SYSTEM = "MXM";

// locales que maneja el frontend (vue-i18n)
export const FRONTEND_LOCALES = {
  EN: "en",
  ES: "es",
};

// locales que maneja el backend
export const BACKEND_LOCALES = {
  EN: "en_US",
  ES: "es_ES",
};

export const WO_EDITION_TYPE = {
  FULL: "full",
  QUICK: "quick",
  DRAG: "drag",
  ALGORITHM: "algorithm",
};

export const PLANNABLE_WORKORDER_STATUSES = new Set(["0", "1", "2", "3", "8"]);

export const isPlannableWorkorderStatus = (status) =>
  PLANNABLE_WORKORDER_STATUSES.has(String(status ?? ""));
